// @flow
import styled, { css } from 'styled-components'

const cssFromProp = (propName, cssPropertyName = propName) => (props) =>
  props[propName] ? `${cssPropertyName}: ${props[propName]}` : ''

const flexBoxStyles = css`
  display: flex;

  ${cssFromProp('direction', 'flex-direction')};
  ${cssFromProp('justify', 'justify-content')};
  ${cssFromProp('align', 'align-items')};
  ${cssFromProp('margin')};
  ${cssFromProp('padding')};
  ${cssFromProp('flex')};
  ${cssFromProp('width')};
  ${cssFromProp('position')};
  ${cssFromProp('height')};
`

const FlexBox = styled.div`
  ${flexBoxStyles};
`

export { flexBoxStyles }
export default FlexBox
